import { StamdataNordenHelgradModel } from '../../Models/StamdataNordenHelgradModel';

export const SET_SATSER = 'SET_SATSER';

export interface SetSatserAction {
    type: typeof SET_SATSER;
    payload: StamdataNordenHelgradModel;
}

export type SatserActionTypes = SetSatserAction;